export default __webpack_public_path__ + "assets/e9173721a2c8ae55508f1e1780d943db.woff";